export const calendarMonth_May = "Wpa";
export default {calendarMonth_May};